function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "rotate(90 12 12)"
}), React.createElement("path", {
  fill: "#ED1C24",
  d: "M12.984 19.002V7.315l5.388 5.413c.372.375.977.375 1.349 0 .373-.377.373-.987 0-1.363l-7.046-7.083c-.372-.376-.977-.376-1.349 0l-.006.006c-.025.022-.047.045-.069.069L4.28 11.365c-.373.376-.373.986 0 1.363.372.375.977.375 1.349 0l5.357-5.383v11.657c0 .552.449.998.999.998.552 0 .999-.446.999-.998z",
  transform: "rotate(90 12 12)"
}));

var SvgRight = function SvgRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right.53db3a07.svg";
export { ForwardRef as ReactComponent };